import React from 'react'
import { Route } from 'react-router-dom'
import { CONFIGURATION } from 'core/routing/constants'
import Configuration from '.'

const router = <Route exact path={CONFIGURATION} component={Configuration} />

export default router
